import {
  Box,
  Button,
  Drawer,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PagesDetailAccordion from "./PagesDetailAccordian";
import {
  PAP_Category_Item_GetrowApi,
  PAP_Item_Pages_GetrowApi,
  PAP_Pages_Verify_UpdateApi,
} from "../../../Server/ApiV2";
import { useEffect, useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";

import SideNavToolbar from "../Components/SidenavToolbar";
import SideNavHeader from "../Components/SideNavHeader";
import {
  exportToExcel,
  fAlertToast,
  hasNonEnterStatus,
} from "../../../Utility/Utilitys";
import ItemVerfication from "./ItemVerfication";
import theme from "../../../Theme";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const ItemSelectionSideNav = ({
  open,
  onClose,
  data,
  setSelectedPromo,
  pageType,
  userCd,
  loadSummary,
}) => {
  const [sDetailData, setDetailData] = useState([]);
  const [sDetailItemData, setDetailItemData] = useState([]);

  useEffect(() => {
    if (open) {
      if (pageType === "Items") {
        fGetRow();
      } else {
        fItemVerifyGetRow();
      }
    }
  }, [open]);

  const fGetRow = async () => {
    const res = await PAP_Category_Item_GetrowApi({
      TransId: data?.TransId,
    });

    if (res.status === 200) {
      setDetailData(res?.data?.data);
    } else {
      setDetailData([]);
    }
  };

  const fItemVerifyGetRow = async () => {
    const res = await PAP_Item_Pages_GetrowApi({
      TransId: data?.TransId,
    });

    if (res.status === 200) {
      let response = res?.data?.recordset;
      setDetailItemData(response);

      const pageData =
        response?.pageData?.map((page) => ({
          ...page,
          IsVerify: true,
        })) ?? [];

      // Save back into state
      setDetailItemData({
        ...response,
        pageData,
      });

      // ✅ All page checkboxes should be checked initially
      const ids = pageData.map((p) => p.RowId);
      setSelectedPages(ids);
    } else {
      setDetailItemData([]);
      setSelectedPages([]);
    }
  };

  const fVerify = async () => {
    const iArr =
      sDetailItemData?.pageData?.map((page) => ({
        PageId: page.RowId, // or item.RowId if item is from parent loop
        IsVerify: page.IsVerify ? 1 : 0,
      })) ?? [];

    const res = await PAP_Pages_Verify_UpdateApi({
      TransId: data?.TransId,
      detail: iArr,
    });
    console.log(res);

    if (res.status === 200) {
      fAlertToast("SUCCESS", "Items Verified successfully");
      await fItemVerifyGetRow();
      await loadSummary();
    }
  };

  const fClose = async () => {
    onClose();
    setSelectedPromo({});
    if (pageType === "Items") {
      setDetailData([]);
    } else {
      setDetailItemData([]);
      setSelectedPages([]);
    }
  };

  const [selectedPages, setSelectedPages] = useState([]);

  const pageIds = sDetailItemData?.pageData?.map((p) => p.RowId);
  const allSelected =
    pageIds?.length > 0 && selectedPages?.length === pageIds?.length;

  const handleTogglePage = (rowId) => (e) => {
    const { checked } = e.target;
    setSelectedPages((prev) =>
      checked ? [...prev, rowId] : prev.filter((id) => id !== rowId)
    );

    setDetailItemData((prev) => ({
      ...prev,
      pageData: prev.pageData.map((p) =>
        p.RowId === rowId
          ? { ...p, IsVerify: checked } // Update IsVerify based on checkbox state
          : p
      ),
    }));
  };

  const handleSelectAll = (e) => {
    const { checked } = e.target;

    const ids = checked ? pageIds : [];
    setSelectedPages(ids);

    setDetailItemData((prev) => ({
      ...prev,
      pageData: prev.pageData.map((p) => ({
        ...p,
        IsVerify: checked,
      })),
    }));
  };

  // Export the Data like UI
  const exportPageData =
    sDetailData?.pageData?.flatMap((page) => [
      // Page Header Row
      { PageHeader: page.Title },

      // Add all subData objects directly
      ...page.subData.map((item) => ({
        ...item, // Export full object
        Page: page.Page, // Add Page info also
      })),

      // Empty Row for separation
      {},
    ]) || [];

  const exportItemsData =
    sDetailItemData?.pageData?.flatMap((page) => [
      // Page Header Row
      { PageHeader: page.Title },

      // Add all subData objects directly
      ...page.subData.map((item) => ({
        ...item, // Export full object
        Page: page.Page, // Add Page info also
      })),

      // Empty Row for separation
      {},
    ]) || [];

  const exportData = pageType === "Items" ? exportPageData : exportItemsData;

  return (
    <Drawer
      anchor="right"
      open={open}
      PaperProps={{
        sx: {
          mt: 5,
          width: {
            xs: "100%",
            sm: "100%",
            md: pageType === "Items" ? "80%" : "95%",
            lg: pageType === "Items" ? "80%" : "90%",
          },
          height: `calc(100vh - ${theme.spacing(5)})`,
          overflow: "hidden",
          display: "flex", // 👈 important
          flexDirection: "column",
        },
      }}
    >
      <Box
        sx={{
          background: "linear-gradient(135deg, #1e88e5 0%, #673ab7 100%)",
          color: "#fff",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 2,
          py: 1.2,
          borderBottom: "1px solid #1565c0",
        }}
      >
        {" "}
        <div style={{ display: "flex", flexDirection: "row" }}>
          <IconButton
            edge="end"
            onClick={fClose}
            aria-label="close"
            sx={{
              fontSize: "20px !important",
              color: "#ffffff", // 👈 white icon color
              backgroundColor: "rgba(255,255,255,0.15)",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.25)",
              },
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography
            variant="h6"
            sx={{ fontWeight: 500, marginLeft: "22px", marginTop: "4px" }}
          >
            {pageType === "Items"
              ? "Page & Category Detail"
              : "Item Verification"}
          </Typography>
        </div>
        <IconButton
          onClick={fClose}
          sx={{
            color: "#ffffff", // 👈 white icon color
            backgroundColor: "rgba(255,255,255,0.15)",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.25)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <SideNavToolbar
        transId={data?.TransId || ""}
        userCd={userCd}
        selectedRow={data}
        loadSummary={loadSummary}
      />

      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          px: 1.5,
        }}
      >
        <SideNavHeader selectedRow={data} pageType={pageType} />
        {pageType === "Items" && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <Tooltip title="Export CSV">
              <span>
                <IconButton
                  color="primary"
                  onClick={() => {
                    exportToExcel(exportData, pageType, "Items");
                  }}
                >
                  <DownloadIcon />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        )}

        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            mt: 1,
            mb: 2,
            "&::-webkit-scrollbar": { width: 8 },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#b0bec5",
              borderRadius: 4,
            },
          }}
        >
          {pageType === "Items" ? (
            <PagesDetailAccordion
              data={data}
              sDetailData={sDetailData}
              pageType={pageType}
              fGetRow={fGetRow}
              loadSummary={loadSummary}
            />
          ) : (
            <ItemVerfication
              data={data}
              sDetailItemData={sDetailItemData}
              selectedPages={selectedPages}
              allSelected={allSelected}
              handleTogglePage={handleTogglePage}
              handleSelectAll={handleSelectAll}
            />
          )}
        </Box>
      </Box>
      {pageType !== "Items" && (
        <Box
          sx={{
            p: 1.5,
            bgcolor: "#fff",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            color="success"
            onClick={fVerify}
            disabled={hasNonEnterStatus(data)}
            sx={{ textTransform: "capitalize", width: "7%" }}
          >
            Approve
          </Button>
        </Box>
      )}
    </Drawer>
  );
};

export default ItemSelectionSideNav;
